// region Variables
import router from "../../routes/core/engine";


export const STORE_CURRENCY_KEY = '__application_currency'

export const CURRENCY_ZWG = 'ZWG'
export const CURRENCY_USD = 'USD'
export let CURRENCY_CURRENT = localStorage.getItem(STORE_CURRENCY_KEY) || CURRENCY_USD

export const PROVIDER_ZESA = 'ZESA'
export const PROVIDER_ECONET = 'Econet'
export const PROVIDER_NETONE = 'NetOne'
export const PROVIDER_TELONE = 'TelOne'
export const PROVIDER_ZINARA = 'ZINARA'
export const PROVIDER_MOOVAH = 'Moovah'

export const SERVICE_ELECTRICITY = 'Electricity'
export const SERVICE_GIFT_VOUCHERS = 'Gift Vouchers'
export const SERVICE_TICKETS = 'Events'
export const SERVICE_AIRTIME = 'Airtime'
export const SERVICE_BUNDLES = 'Bundles'
export const SERVICE_VEHICLE_LICENCE = 'Vehicle Licence & Insurance'
export const SERVICE_ACCOUNTS = 'Accounts'
export const SERVICE_BILLERS = 'Billers'
export const Calculators = 'Calculators'
// endregion

// region System Status
export const systems = (function () {
    const container = document.querySelector('[data-systems]');

    if (!container) return {};

    const enabled = (value) => {
        if (value === undefined) return true;
        if (value === null) return true;
        if (value === 'null') return true;
        if (value === '') return true;

        if (value === 'ON') return true;

        if (value === 'OFF') return false;

        return !!value;
    }

    return {
        corp_zesa: enabled(container.dataset.corp_zesa),
        corp_econet_zig: enabled(container.dataset.corp_econet_zig),
        corp_econet_usd: enabled(container.dataset.corp_econet_usd),
        corp_netone_zig: enabled(container.dataset.corp_netone_zig),
        corp_netone_usd: enabled(container.dataset.corp_netone_usd),
        zesa: enabled(container.dataset.zesa),
        econet: enabled(container.dataset.econet),
        econet_usd: enabled(container.dataset.econet_usd),
        netone: enabled(container.dataset.netone),
        netone_usd: enabled(container.dataset.netone_usd),
        telone: enabled(container.dataset.telone),
        telone_usd: enabled(container.dataset.telone),
        zinara: enabled(container.dataset.zinara),
        moovah: enabled(container.dataset.moovah),
        giftcards: enabled(container.dataset.giftcards),
        billers: enabled(container.dataset.billers),
        tickets: enabled(container.dataset.tickets),
    }
})();
// endregion

// region Global App Data
export const appDataMixin = {
    data: () => ({
        privateCurrency: localStorage.getItem(STORE_CURRENCY_KEY) || CURRENCY_USD,
        currencies: [CURRENCY_ZWG, CURRENCY_USD],
        flags: {
            [CURRENCY_ZWG]: '/img/flags/zwl.png',
            [CURRENCY_USD]: '/img/flags/usd.jpg',
        },
        logos: {
            NetOne : '/img/providers/NetOne-logo.png',
            Econet: '/img/providers/Econet-logo.png',
        },
    }),
    computed: {
        currency: {
            get() {
                return this.privateCurrency;
            },
            set(value) {
                localStorage.setItem(STORE_CURRENCY_KEY, value)
                this.privateCurrency = value
            }
        },
        services() {
            return [

                {
                    name: 'Calculators',
                    route: '/calculators',
                    icon: '/img/service-icons/Calculator.png',
                    description: 'Magetsi Calculators',
                    options: [
                        {
                            name: 'Zesa Calculator',
                            displayName: 'ZESA Calculator',
                            icon: '/img/service-icons/Calculator.png',
                            description: 'Estimate your electricity costs.',
                            route: '/calculators/zesa-calculator',

                        },
                        {
                            name: 'Currency Exchange Rate Calculator',
                            icon: '/img/service-icons/exchange.png',
                            displayName: 'Currency Exchange Rate Calculator',
                            description: 'Convert currencies with live rates.',
                            route: '/calculators/currency-calculator',

                        },
                        {
                            name: 'Loan Calculator',
                            displayName: 'Loan Calculator',
                            icon: '/img/service-icons/loan-calc.png',
                            description: 'Calculate loan payments easily.',
                            route: '/calculators/loan-calculator',

                        },
                        {
                            name: 'Mortgage Calculator',
                            displayName: 'Mortgage Calculator',
                            icon: '/img/service-icons/mortgage.png',
                            description: 'Plan monthly home loan costs.',
                            route: '/calculators/mortgage-calculator',

                        },
                        {
                            name: 'Savings Growth Calculator',
                            displayName: 'Savings Growth Calculator',
                            icon: '/img/service-icons/savings.jpg',
                            description: 'Track savings growth over time.',
                            route: '/calculators/savings-calculator',
                        },

                        {
                            name: 'Solar Panel Savings Calculator',
                            displayName: 'Solar Panel Savings Calculator',
                            icon: '/img/service-icons/solar.png',
                            description: 'See savings from using solar power',
                            route: '/calculators/solar-savings-calculator',
                        },

                    ]
                },

                {
                    name: SERVICE_ELECTRICITY,
                    route: '/zesa',
                    icon: '/img/service-icons/electricity.svg',
                    displayName: 'ZESA Tokens',
                    description: 'Buy ZESA Tokens',
                    image: '/img/providers/ZETDC-logo.png',
                    provider: PROVIDER_ZESA,
                    disabled: systems.zesa === false,
                },
                {
                    name: SERVICE_AIRTIME,
                    route: '/airtime',
                    icon: '/img/service-icons/airtime.svg',
                    description: 'Buy Econet & NetOne Airtime',
                    options: [
                        {
                            name: 'USD',
                            route: '/airtime',
                            image: '/img/providers/Econet-usd.png',
                            provider: PROVIDER_ECONET,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.econet_usd === false,
                        },
                        {
                            name: 'Econet',
                            route: '/airtime/zwg',
                            image: '/img/providers/Econet_ZWG.webp',
                            provider: PROVIDER_ECONET,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.econet_usd === false,
                        },
                        {
                            name: 'NetOne',
                            route: '/airtime/netone',
                            image: '/img/providers/Netone-usd.png',
                            provider: PROVIDER_NETONE,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.netone_usd === false,
                        },
                        {
                            name: '',
                            route: '/sending-airtime-to-zimbabwe',
                            image: '/img/providers/Econet-usd.png',
                            provider: PROVIDER_ECONET,
                            currencies: [CURRENCY_USD],
                            disabled: systems.netone_usd === false,
                            seo: true
                        },
                        {
                            name: '',
                            displayName: 'NetOne Voice & Data Bundles',
                            route: '/how-to-buy-netone-airtime-using-ecocash',
                            image: '/img/providers/Netone-usd.png',
                            provider: PROVIDER_NETONE,
                            currencies: [CURRENCY_USD],
                            disabled: systems.netone_usd === false,
                            seo: true
                        }
                    ]
                },
                {
                    name: SERVICE_BUNDLES,
                    route: '/bundles',
                    description: 'Buy Econet & NetOne Bundles',
                    icon: '/img/service-icons/bundles.svg',
                    options: [
                        {
                            name: 'USD',
                            route: '/bundles',
                            displayName: {
                                [CURRENCY_USD]: 'Smart USD Bundles'
                            }[this.currency],
                            altRoute: '/bundles',
                            provider: PROVIDER_ECONET,
                            image: '/img/providers/Econet-usd.png',
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.econet_usd === false,
                        },
                        {
                            name: 'SmartBiz',
                            displayName:'Econet SmartBiz',
                            route: '/bundles/smartbiz',
                            provider: PROVIDER_ECONET,
                            image: '/img/providers/smartbiz.png',
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.econet_usd === false,
                        },
                        {
                            name: 'NetOne',
                            displayName: 'NetOne Voice & Data Bundles',
                            description: 'Buy NetOne Airtime, Voice & Data Bundles',
                            route: '/bundles/netone',
                            provider: PROVIDER_NETONE,
                            image: '/img/providers/Netone-usd.png',
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.netone_usd === false,
                            /*disabledMessage: 'NetOne ZWG Bundles are currently not available. Please consider buying NetOne USD bundles for voice calls and data instead.',
                            disabledAction: {
                                action: () => this.toggleCurrency(CURRENCY_USD),
                                text: 'Buy USD Voice & Data Bundles'
                            }*/
                        },
                        {
                            name: 'TelOne ZWG',
                            displayName: {
                                [CURRENCY_ZWG]: 'TelOne ZWG Bundles'
                            }[this.currency],
                            route: '/bundles/telone/zwg',
                            provider: PROVIDER_TELONE,
                            image: '/img/providers/zwg-telone.webp',
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.telone === false,
                        },
                        {
                            name: "TelOne USD",
                            displayName: 'TelOne USD Bundles',
                            route: '/bundles/telone',
                            provider: PROVIDER_TELONE,
                            image: '/img/providers/usd-telone.png',
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.telone_usd === false,
                        },
                        {
                            name: 'Econet',
                            route: '/bundles/zwg',
                            displayName: {
                                [CURRENCY_ZWG]: 'Econet ZWG Bundles'
                            }[this.currency],
                            altRoute: '/bundles/zwg',
                            provider: PROVIDER_ECONET,
                            image: '/img/providers/Econet_ZWG.webp',
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.econet === false,
                        },
                    ]
                },
                {
                    name: PROVIDER_TELONE,
                    route: '/telone',
                    image: '/img/providers/TelOne-logo.png',
                    icon: '/img/service-icons/wifi.svg',
                    description: 'TelOne Bundles & Account Services',
                    options: [
                        {
                            displayName: 'TelOne Direct Recharge',
                            name: 'Recharge ZWG',
                            route: '/telone',
                            provider: PROVIDER_TELONE,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.telone === false,
                        },
                        {
                            displayName: 'TelOne Direct Recharge USD',
                            name: 'Recharge USD',
                            route: '/telone/usd',
                            provider: PROVIDER_TELONE,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.telone_usd === false,
                        },
                        {
                            displayName: 'TelOne WiFi Packages',
                            name: 'Recharge USD',
                            route: '/telone-wifi-packages',
                            provider: PROVIDER_TELONE,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.telone_usd === false,
                            seo: true
                        },
                        {
                            displayName: 'TelOne Bundles',
                            name: 'Purchase Bundle',
                            route: '/bundles/telone/zwg',
                            provider: PROVIDER_TELONE,
                            currencies: [CURRENCY_ZWG, CURRENCY_USD],
                            disabled: systems.telone === false,
                        },
                        {
                            displayName: 'TelOne Merchant Bill',
                            name: 'Pay Bill',
                            route: '/telone/bill',
                            provider: PROVIDER_TELONE,
                            disabled: systems.telone === false,
                        }
                    ]
                },
                {
                    name: SERVICE_BILLERS,
                    displayName: 'Billers',
                    route: '/billers',
                    icon: '/img/service-icons/billers.svg',
                    description: 'Pay your billers through Magetsi',
                    disabled: systems.billers === false,
                },
                {
                    name: SERVICE_GIFT_VOUCHERS,
                    displayName: 'Gift Vouchers',
                    route: '/gift-vouchers',
                    icon: '/img/service-icons/gift-card.svg',
                    description: 'Buy Gift Cards for your loved ones',
                    disabled: systems.giftcards === false,
                },
                {
                    name: SERVICE_TICKETS,
                    displayName: 'Events & Tickets',
                    route: '/tickets',
                    icon: '/img/service-icons/tickets.svg',
                    description: 'Buy tickets for your loved ones',
                    disabled: systems.tickets === false,
                },

                {
                    name: 'Vehicle Licence, Insurance & Radio',
                    route: '/zinara',
                    description: 'Buy ZINARA Vehicle Licence & Moovah Vehicle Insurance',
                    icon: '/img/service-icons/zinara.svg',
                    options: [
                        {
                            name: 'Vehicle Insurance',
                            route: '/zinara',
                            provider: PROVIDER_ZINARA,
                            image: '/img/providers/Moovah-logo.png',
                            image2: '/img/providers/Zinara-logo.png',
                            image3: '/img/providers/zbc.webp',
                            offers:'Free Delivery',
                            displayName: 'ZINARA Vehicle Licence',
                            poweredBy:'Powered by Econet Insurance',
                            disabled: systems.moovah === false,
                        },/*
                        {
                            name: 'Vehicle Licence',
                            service: '',
                            route: '/zinara/buy',
                            provider: PROVIDER_ZINARA,
                            image: '/img/providers/Zinara-logo.png',
                            displayName: 'ZINARA Vehicle Licence',
                            disabled: systems.zinara === false,
                        },*/
                    ]
                },
            ]
        },
        flatServices() {
            const services = [...this.services]

            for (const service of this.services) {
                if (Array.isArray(service.options)) {
                    services.push(...service.options.map(s => ({
                        ...s,
                        disabled: s.disabled || service.disabled,
                        service: s.service || service.name,
                        image: s.image || service.image,
                    })))
                } else {
                    services.push(service)
                }
            }

            const result = {}

            for (const service of services) {
                const normalisedService = {
                    ...service,
                    displayName: this.serviceName(service)
                }
                result[service.route] = normalisedService

                if (service.altRoute) {
                    result[service.altRoute] = normalisedService
                }
            }

            return result;
        },
        flatServicesList() {
            return Object
                .values(this.flatServices)
                .filter(service => service.disabled !== true)
                .reduce((acc, curr) => {
                    if (!acc.find(item => item.route === curr.route)) {
                        acc.push(curr);
                    }
                    return acc;
                }, []);
        },
        providerServices() {
            const services = {}
            const providerServices = (service, serviceName) => {
                if (service.provider) {
                    const group = services[service.provider] || {
                        provider: service.provider,
                        services: []
                    }

                    group.services.push({...service, service: serviceName || service.name})

                    services[service.provider] = group
                }
            }

            for (const service of this.services) {
                providerServices(service)

                for (const option of service.options || []) {
                    providerServices(option, service.name)
                }
            }

            return Object.values(services)
        },
        providers() {
            return [...new Set(Object.values(this.flatServices).map(s => s.provider))]
        },
        oppositeCurrency() {
            return this.currency === CURRENCY_ZWG ? CURRENCY_USD : CURRENCY_ZWG
        }
    },
    methods: {
        scrollToTop(){
            window.scrollTo({ top: 240, behavior: 'smooth' });
        },
        switchCurrency(option) {
            const currencyMap = {
                'Econet': CURRENCY_ZWG,
                'USD': CURRENCY_USD,
                'SmartBiz': CURRENCY_USD,
                'NetOne': CURRENCY_USD,
                'Purchase Bundle': CURRENCY_ZWG,
                'Recharge USD': CURRENCY_USD,
                'Recharge ZWG': CURRENCY_ZWG,
                'TelOne ZWG': CURRENCY_ZWG,
                'TelOne USD': CURRENCY_USD
            };

            const newCurrency = currencyMap[option.name];

            if (newCurrency && this.currency !== newCurrency) {
                this.currency = newCurrency;
                window.location.reload();
            }
        },
        toggleCurrency(newCurrency = null) {
            const changeCurrency = newCurrency || (this.currency === CURRENCY_ZWG ? CURRENCY_USD : CURRENCY_ZWG);

            const extra = changeCurrency === CURRENCY_USD ? ' USD products are only payable in USD.' : ''

            window.alerts
                .confirm(
                    `Are you sure you want to browse our ${changeCurrency} products?${extra} Note this will reload the page.`, `Switch to ${changeCurrency} Products`)
                .then((changed) => {

                    if (changed) {
                        this.currency = changeCurrency;
                        window.location.reload();
                    } else {
                        router.go(-1);
                    }
                })
        },
        serviceName(service) {
            return service.displayName || this.removeDuplicates([service.provider, service.name, ...(service.service || '').split(' ')]).join(' ')
        },
        removeDuplicates(array) {
            return array
                .filter(a => !!a)
                .filter((a, b) => array.indexOf(a) === b)
        },
        serviceDisabled(serviceOrProvider) {
            if (!serviceOrProvider) return false

            if (serviceOrProvider.disabled) return true

            if (serviceOrProvider.currencies) {
                return !serviceOrProvider.currencies.includes(this.currency)
            }

            return false
        }
    }

}
// endregion
export const permissionsMixin = {
    methods: {
        hasPermission(permissions, permission) {
            if (!permissions || !Array.isArray(permissions)) {
                console.warn("Permissions object is missing or invalid:", permissions);
                return false;
            }
            return permissions.some(p => p.name === permission);
        }
    }

}

export const datesMixin = {
    methods: {
        formattedDate(dateString) {
            const date = new Date(dateString);
            const day = date.getDate().toString().padStart(2, '0');
            const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
            return `${day} ${month}`;
        }
    }

}
